import React from 'react';

export const ReviewedByMicrodataSchema = ({authorParams, pageUrl="www.365score.com"}) => {
  if (!authorParams?.authorName || !authorParams?.authorJobTitle || !authorParams?.authorUrl) {
    return null;
  }

  const {
    authorName,
    authorDescription,
    authorJobTitle,
    authorUrl,
    authorKnowsAbout,
    authorKnowsLanguage,
    authorSocialLinks
  } = authorParams;

  const containerProps = {
    itemScope: true,
    itemProp: 'reviewedBy',
    itemType: "https://schema.org/Person",
  }

  return <>
    <div {...containerProps}>
      <meta itemProp={"name"} content={authorName}/>
      {
        authorDescription ? <meta itemProp={"description"} content={authorDescription}/> : null
      }
      <meta itemProp={"jobTitle"} content={authorJobTitle}/>
      <meta itemProp={"url"} content={authorUrl}/>
      {
        authorKnowsAbout ? <meta itemProp={"knowsAbout"} content={authorKnowsAbout}/> : null
      }
      {
        authorKnowsLanguage ? <meta itemProp={"knowsLanguage"} content={authorKnowsLanguage}/> : null
      }
      {
        authorSocialLinks?.map((link, index) => <meta key={index} itemProp={"sameAs"} content={link}/>)
      }
    </div>
    <div itemProp="potentialAction" itemScope itemType="https://schema.org/ReadAction">
      <div itemProp="target" itemScope itemType="https://schema.org/EntryPoint">
        <meta itemProp="urlTemplate" content={pageUrl}/>
      </div>
    </div>
  </>
};